// assets
import { breadcrumbsClasses } from "@mui/material";
import {
  IconUser,
  IconBrandChrome,
  IconMap,
  IconDeviceSim,
  IconReport,
  IconDeviceSim1,
  IconTag,
  IconUrgent,
  IconCircleCheck,
  IconChecks,
  IconBan,
  IconUsers,
  IconRoute,
  IconCalendarTime,
  IconCalculator,
  IconMapPin,
  IconFileInvoice,
  IconKey,
  IconArchive,
  IconBolt,
  IconId,
  IconTruckDelivery,
  IconShieldCheck,
  IconClipboardCheck,
  IconDeviceAnalytics,
 IconDevices2,
} from "@tabler/icons";

const icons = {
  IconUser,
  IconUsers,
  IconBrandChrome,
  IconMap,
  IconDeviceSim,
  IconReport,
  IconDeviceSim1,
  IconTag,
  IconUrgent,
  IconCircleCheck,
  IconChecks,
  IconBan,
  IconRoute,
  IconCalendarTime,
  IconCalculator,
  IconMapPin,
  IconFileInvoice,
  IconKey,
  IconArchive,
  IconBolt,
  IconId,
  IconTruckDelivery,
  IconShieldCheck,
  IconClipboardCheck,
  IconDeviceAnalytics,
   IconDevices2,
};

// ==============================|| UTILITIES MENU ITEMS ||============================== //
const user = {
  id: "utilities",
  type: "group",

  children: [
    {
      id: "extra-module",
      title: "Extra Modules",
      type: "collapse",
      icon: icons.IconBrandChrome,
      roles: ["superadmin"],
      children: [
        {
          id: "server-health",
          title: "Server Health",
          type: "item",
          url: "/extra/server-health",
          breadcrumbs: false,
          roles: ["superadmin"],
        },
        {
          id: "alert-stats",
          title: "Alert Stats",
          type: "item",
          url: "/extra/alert-stats",
          breadcrumbs: false,
          roles: ["superadmin"],
        },
        {
          id: "device-inspector",
          title: "Device Inspector",
          type: "item",
          url: "/extra/device-inspector",
          breadcrumbs: false,
          roles: ["superadmin"],
        },
        {
          id: "packet-validator",
          title: "Packet Validator",
          type: "item",
          url: "/extra/packet-validator",
          breadcrumbs: false,
          roles: ["superadmin"],
        },
      ],
    },
    {
      id: "new-icons",
      title: "Create New",
      type: "collapse",
      icon: icons.IconUser,
      roles: ["superadmin", "stateadmin", "dealer", "sosadmin", "certificateadmin"],
      children: [
        // {
        //   id: "state-admin",
        //   title: "State Admin",
        //   type: "item",
        //   url: "/user/newStateAdmin",
        //   breadcrumbs: false,
        //   roles: ["superadmin"],
        // },
        // {
        //   id: "esim-user",
        //   title: "M2M Service Provider",
        //   type: "item",
        //   url: "/user/newEsimUser",
        //   breadcrumbs: false,
        //   roles: ["superadmin"],
        // },
        {
          id: "manufacturer-user",
          title: "Manufacturer",
          type: "item",
          url: "/user/newManufacturer",
          breadcrumbs: false,
          roles: ["superadmin"],
        },
        // {
        //   id: "dto-user",
        //   title: "DTO",
        //   type: "item",
        //   url: "/user/newDto",
        //   breadcrumbs: false,
        //   roles: ["stateadmin"],
        // },
        {
          id: "dealer-account",
          title: "Dealer Account",
          type: "item",
          url: "/user/newDealerAccount",
          breadcrumbs: false,
          roles: ["stateadmin", "superadmin"],
        },
        {
          id: "technician-account",
          title: "Create Technician Account",
          type: "item",
          url: "/user/create-technician",
          breadcrumbs: false,
          roles: ["superadmin"],
        },
        {
          id: "certificate-admin-account",
          title: "Create Certificate Admin Account",
          type: "item",
          url: "/user/create-certificateadmin",
          breadcrumbs: false,
          roles: ["superadmin"],
        },
        {
          id: "certificate-teamlead-account",
          title: "Create Certificate Team Lead Account",
          type: "item",
          url: "/user/create-certificateteamlead",
          breadcrumbs: false,
          roles: ["superadmin", "certificateadmin"],
        },
        {
          id: "certificate-executive-account",
          title: "Create Certificate Executive Account",
          type: "item",
          url: "/user/create-certificate-executive",
          breadcrumbs: false,
          roles: ["superadmin", "certificateadmin"],
        },
        {
          id: "create-vehicle-make",
          title: "Create Vehicle Make",
          type: "item",
          url: "/new/CreateVehicleMake",
          breadcrumbs: false,
          roles: ["superadmin"],
        },
        {
          id: "create-vehicle-model",
          title: "Create Vehicle Model",
          type: "item",
          url: "/new/CreateVehicleModel",
          breadcrumbs: false,
          roles: ["superadmin"],
        },
        {
          id: "vehicle-owner",
          title: "Create Vehicle Owner",
          type: "item",
          url: "/new/vehicleOwner",
          breadcrumbs: false,
          roles: ["dealer"],
        },
        // {
        //   id: "sos-admin",
        //   title: "SOS Admin",
        //   type: "item",
        //   url: "/new/sos-admin",
        //   breadcrumbs: false,
        //   roles: ["superadmin"],
        // },
        {
          id: "system-admin",
          title: "System Admin",
          type: "item",
          url: "/new/system-admin",
          breadcrumbs: false,
          roles: ["superadmin"],
        },
        {
          id: "sos-user",
          title: "SOS User",
          type: "item",
          url: "/new/sos-user",
          breadcrumbs: false,
          roles: ["sosadmin"],
        },
        // {
        //   id: "create-holiday",
        //   title: "Create Holiday",
        //   type: "item",
        //   url: "/setting/holiday/new",
        //   breadcrumbs: false,
        //   roles: ["superadmin", "owner"],
        // },

      ],
    },
    // {
    //   id: "m2m-registration-requests",
    //   title: "M2M Registration Requests",
    //   type: "item",
    //   url: "/superadmin-dashboard/m2m-registration-requests",
    //   icon: icons.IconCircleCheck,
    //   breadcrumbs: false,
    //   roles: ["superadmin"],
    // },
    // {
    //   id: "manufacturer-registration-requests",
    //   title: "Vehicle Manufacturer Requests",
    //   type: "item",
    //   url: "/superadmin-dashboard/vehicle-manufacturer-registration-requests",
    //   icon: icons.IconCircleCheck,
    //   breadcrumbs: false,
    //   roles: ["superadmin", "stateadmin"],
    // },
    // {
    //   id: "ais140-manufacturer-registration-requests",
    //   title: "AIS-140 Manufacturer Requests",
    //   type: "item",
    //   url: "/superadmin-dashboard/ais-140-device-manufacturer-registration-requests",
    //   icon: icons.IconCircleCheck,
    //   breadcrumbs: false,
    //   roles: ["superadmin", "stateadmin"],
    // },
    // {
    //   id: "technical-onboarding-requests",
    //   title: "Technical Onboarding Requests",
    //   type: "item",
    //   url: "/superadmin-dashboard/technical-onboarding-requests",
    //   icon: icons.IconChecks,
    //   breadcrumbs: false,
    //   roles: ["superadmin"],
    // },
    {
      id: "new-icons-em-team",
      title: "EM Team",
      type: "collapse",
      icon: icons.IconUsers,
      roles: ["sosadmin"],
      children: [
        {
          id: "em-team",
          title: "Create",
          type: "item",
          url: "/new/em-team",
          breadcrumbs: false,
          roles: ["sosadmin"],
        },
        {
          id: "em-team-list",
          title: "List",
          type: "item",
          url: "/list/em-team",
          breadcrumbs: false,
          roles: ["sosadmin"],
        },
      ],
    },
    {
      id: "sos-call-list",
      title: "SOS Call List",
      type: "item",
      url: "/sos-call-list",
      icon: icons.IconUrgent,
      breadcrumbs: false,
      roles: ["desk_ex", "teamlead"],
    },
    {
      id: "route-fixing",
      title: "Route Fixing",
      type: "item",
      url: "/route-fixing",
      icon: icons.IconMap,
      breadcrumbs: false,
      roles: ["superadmin", "owner", "dtorto"],
    },
    {
      id: "route-eta",
      title: "Trip monitor",
      type: "item",
      url: "/route-eta",
      icon: icons.IconCalculator,
      breadcrumbs: false,
      roles: ["owner"],
    },
    {
      id: "live-tracking",
      title: "Live Tracking",
      type: "item",
      url: "/live-tracking",
      icon: icons.IconMap,
      breadcrumbs: false,
      roles: ["superadmin", "stateadmin", "owner", "dtorto"],
    },
    {
      id: "M2m Esim",
      title: "Esim Activation Management",
      type: "item",
      url: "/esimActivationmanagement",
      icon: icons.IconDeviceSim1,
      breadcrumbs: false,
      roles: ["superadmin"],
    },
    {
      id: "Token Management",
      title: "Token Management",
      type: "item",
      url: "/tokenmanagement",
      icon: icons.IconKey,
      breadcrumbs: false,
      roles: ["superadmin"],
    },
    {
      id: "OBD Data",
      title: "OBD Data",
      type: "item",
      url: "/obd-data",
      icon: icons.IconKey,
      breadcrumbs: false,
      roles: ["superadmin", "devicemanufacture"],
    },
    {
      id: "history-playback",
      title: "History Playback",
      type: "item",
      url: "/history-playback",
      icon: icons.IconMap,
      breadcrumbs: false,
      roles: ["superadmin", "stateadmin", "owner", "dtorto"],
    },
    {
      id: "trip-viewer",
      title: "Trip Viewer",
      type: "item",
      url: "/trip-viewer",
      icon: icons.IconMap,
      breadcrumbs: false,
      roles: ["superadmin", "owner", "dtorto"],
    },
    {
      id: "access-manage",
      title: "Access Manage",
      type: "item",
      url: "/access-manage",
      icon: icons.IconShieldCheck,
      breadcrumbs: false,
      roles: ["superadmin", "certificateadmin"],
    },
    {
      id: "devices-heaths",
      title: "Device Health",
      type: "item",
      url: "/devices-healths",
      icon: icons.IconDeviceAnalytics,
      breadcrumbs: false,
      roles: ["superadmin", "devicemanufacture"],
    },
    {
      id: "certificate-review",
      title: "Certificate Revier",
      type: "item",
      url: "/certificate/review-queue",
      icon: icons.IconClipboardCheck,
      breadcrumbs: false,
      roles: ["superadmin", "certificateadmin", "certificateteamlead"],
    },
    {
      id: "certificate-job-queue",
      title: "Job Queue",
      type: "item",
      url: "/certificate/job-queue",
      icon: icons.IconClipboardCheck,
      breadcrumbs: false,
      roles: ["certificateexecutive"],
    },
    {
      id: "certificate-device-installed",
      title: "Install Devices",
      type: "item",
      url: "/certificate/device-installed",
      icon: icons.IconDevices2,
      breadcrumbs: false,
      roles: ["superadmin"],
    },
    {
      id: "certificate-agent-performance",
      title: "Agent Performance",
      type: "item",
      url: "/certificate/agent-performance",
      icon: icons.IconClipboardCheck,
      breadcrumbs: false,
      roles: ["superadmin","certificateadmin"],
    },
    {
      id: "inventory",
      title: "Inventory",
      type: "item",
      url: "/inventory",
      icon: icons.IconArchive,
      breadcrumbs: false,
      roles: ["esimmanager"],
    },
    {
      id: "bootstrap",
      title: "Bootstrap Activation List",
      type: "item",
      url: "/bootstrap-activation",
      icon: icons.IconBolt,
      breadcrumbs: false,
      roles: ["esimmanager"],
    },
    {
      id: "commercial",
      title: "Commercial Activation",
      type: "item",
      url: "/commercial",
      icon: icons.IconBolt,
      breadcrumbs: false,
      roles: ["esimmanager"],
    },
    
    {
      id: "kycreport",
      title: "Kyc Report",
      type: "item",
      url: "/kycreport",
      icon: icons.IconId,
      breadcrumbs: false,
      roles: ["esimmanager"],
    },
    {
      id: "stockmasterreport",
      title: "Stocks Report Overview",
      type: "item",
      url: "/stock-master-reports",
      icon: icons.IconId,
      breadcrumbs: false,
      roles: ["esimmanager","superadmin"],
    },
    {
      id: "factory-stock-upload",
      title: "Factory Stock Upload",
      type: "item",
      url: "/factory-stock-upload",
      icon: icons.IconArchive,
      breadcrumbs: false,
      roles: ["factorymanager"],
    },
    {
      id: "device-config-console",
      title: "Device Config Console",
      type: "item",
      url: "/device-config-console",
      icon: icons.IconSettingsAutomation,
      breadcrumbs: false,
      roles: ["factorymanager"],
    },
    {
      id: "safecustody",
      title: "Safe Custody",
      type: "item",
      url: "/safe-custody",
      icon: icons.IconBolt,
      breadcrumbs: false,
      roles: ["factorymanager","devicemanufacture","dealer","esimmanager"],
    },
    {
      id: "device-feature-assign",
      title: "Device Feature Assign",
      type: "item",
      url: "/device-feature-assign",
      icon: icons.IconSettingsAutomation,
      breadcrumbs: false,
      roles: ["factorymanager"],
    },
    {
      id: "factory-dispatch",
      title: "Factory Dispatch",
      type: "item",
      url: "/factory-dispatch",
      icon: icons.IconSettingsAutomation,
      breadcrumbs: false,
      roles: ["factorymanager"],
    },
    {
      id: "bulk-dispatch",
      title: "Bulk Fota",
      type: "item",
      url: "/bulk-dispatch",
      icon: icons.IconTruckDelivery,
      breadcrumbs: false,
      roles: ["factorymanager"],
    },
    // {
    //   id: "sos-tracking",
    //   title: "SOS Admin",
    //   type: "item",
    //   url: "/sos-alert",
    //   icon: icons.IconUrgent,
    //   breadcrumbs: false,
    //   roles: ["superadmin", "sosadmin"],
    // },
    // {
    //   id: "sos-lead",
    //   title: "SOS Lead",
    //   type: "item",
    //   url: "/sos-lead-exp",
    //   icon: icons.IconUrgent,
    //   breadcrumbs: false,
    //   roles: ["superadmin", "sosadmin", "teamlead"],
    // },
    // {
    //   id: "sos-user",
    //   title: "SOS Executive",
    //   type: "item",
    //   url: "/sos-exe",
    //   icon: icons.IconUrgent,
    //   breadcrumbs: false,
    //   roles: ["superadmin", "sosadmin", "teamlead"],
    // },
    {
      id: "provider-device-list-pending",
      title: "Activation",
      type: "item",
      url: "/device/activation-request/pending",
      icon: icons.IconCircleCheck,
      breadcrumbs: false,
      roles: ["esimprovider"],
    },
    {
      id: "provider-device-list-invalid",
      title: "Rejected",
      type: "item",
      url: "/device/activation-request/invalid",
      icon: icons.IconBan,
      breadcrumbs: false,
      roles: ["esimprovider"],
    },
    {
      id: "provider-device-list-valid",
      title: "Accepted",
      type: "item",
      url: "/device/activation-request/valid",
      icon: icons.IconChecks,
      breadcrumbs: false,
      roles: ["esimprovider"],
    },
    // {
    //   id: "check-esim-status",
    //   title: "Check eSIM Status",
    //   type: "item",
    //   url: "/device/esim-status",
    //   icon: icons.IconDeviceSim1,
    //   breadcrumbs: false,
    //   roles: ["dealer"],
    // },
    {
      id: "dealer-commercial-activation",
      title: "Commercial Activation",
      type: "item",
      url: "/device/commercial-activation",
      icon: icons.IconBolt,
      breadcrumbs: false,
      roles: ["dealer"],
    },
    // {
    //   id: "activate-esim-device",
    //   title: "Request eSIM Activation",
    //   type: "item",
    //   url: "/device/eSimActivation",
    //   icon: icons.IconDeviceSim1,
    //   breadcrumbs: false,
    //   roles: ["dealer"],
    // },
    // device management
    // {
    //   id: "device-management",
    //   title: "Device Management",
    //   type: "collapse",
    //   icon: icons.IconDeviceSim,
    //   roles: ["superadmin", "stateadmin"],
    //   children: [
    //     {
    //       id: "view-device",
    //       title: "Model Awaiting Approval",
    //       type: "item",
    //       url: "/device/list",
    //       breadcrumbs: false,
    //       roles: ["superadmin", "stateadmin"],
    //     },
    //     {
    //       id: "view-device-cop",
    //       title: "Awaiting COP Device List",
    //       type: "item",
    //       url: "/deviceCOP/list",
    //       breadcrumbs: false,
    //       roles: ["superadmin", "stateadmin"],
    //     },
    //     {
    //       id: "approved-models",
    //       title: "Approved Models",
    //       type: "item",
    //       url: "/device/approved-models",
    //       breadcrumbs: false,
    //       roles: ["superadmin", "stateadmin"],
    //     },
    //     {
    //       id: "approved-cops",
    //       title: "Approved COPs",
    //       type: "item",
    //       url: "/device/approved-cops",
    //       breadcrumbs: false,
    //       roles: ["superadmin", "stateadmin"],
    //     },
    //   ]
    // },
    {
      id: "device-model",
      title: "Device Model",
      type: "collapse",
      icon: icons.IconDeviceSim1,
      roles: ["devicemanufacture"],
      children: [
        {
          id: "new-device-model",
          title: "Create Model",
          type: "item",
          url: "/deviceModel/new",
          breadcrumbs: false,
          roles: ["devicemanufacture"],
        },
        // {
        //   id: "device-model-extension",
        //   title: "TAC Extension",
        //   type: "item",
        //   url: "/deviceModel/extension",
        //   breadcrumbs: false,
        //   roles: ["devicemanufacture"],
        // }
      ]
    },
    // {
    //   id: "manufacturer-technical-onboarding",
    //   title: "Technical Onboarding",
    //   type: "collapse",
    //   icon: icons.IconChecks,
    //   roles: ["devicemanufacture"],
    //   children: [
    //     {
    //       id: "manufacturer-technical-onboarding-create",
    //       title: "New Request",
    //       type: "item",
    //       url: "/manufacturer/technical-onboarding/create",
    //       breadcrumbs: false,
    //       roles: ["devicemanufacture"],
    //     },
    //     {
    //       id: "manufacturer-technical-onboarding-list",
    //       title: "My Requests",
    //       type: "item",
    //       url: "/manufacturer/technical-onboarding/list",
    //       breadcrumbs: false,
    //       roles: ["devicemanufacture"],
    //     },
    //   ],
    // },
    // {
    //   id: "accessory-management",
    //   title: "Accessory Management",
    //   type: "collapse",
    //   icon: icons.IconDeviceSim1,
    //   roles: ["devicemanufacture"],
    //   children: [
    //     {
    //       id: "new-accessory",
    //       title: "Individual Accessory",
    //       type: "item",
    //       url: "/accessory/new",
    //       breadcrumbs: false,
    //       roles: ["devicemanufacture"],
    //     }
    //   ]
    // },
    {
      id: "device-stock",
      title: "Device Stock",
      type: "collapse",
      icon: icons.IconDeviceSim1,
      roles: ["devicemanufacture", "factorymanager", "dealer"],
      children: [
        // {
        //   id: "new-device",
        //   title: "Individual Stock",
        //   type: "item",
        //   url: "/device/new",
        //   breadcrumbs: false,
        //   roles: ["devicemanufacture"],
        // },
        // {
        //   id: "upload-device",
        //   title: "Bulk Stock",
        //   type: "item",
        //   url: "/device/bulkupload",
        //   breadcrumbs: false,
        //   roles: ["devicemanufacture"],
        // },
        {
          id: "assign-device",
          title: "Assign Stock",
          type: "item",
          url: "/device/assign-device",
          breadcrumbs: false,
          roles: ["devicemanufacture"],
        },
        {
          id: "device-inbound",
          title: "Device Inbound",
          type: "item",
          url: "/device/dispatch-inbound",
          breadcrumbs: false,
          roles: ["devicemanufacture", "factorymanager", "dealer"],
        },
        {
          id: "device-outbound",
          title: "Device Outbound",
          type: "item",
          url: "/device/dispatch-outbound",
          breadcrumbs: false,
          roles: ["devicemanufacture", "factorymanager", "dealer"],
        },
        // {
        //   id: "bulk-assign-device",
        //   title: "Bulk Assign Stock",
        //   type: "item",
        //   url: "/device/bulk-assign",
        //   breadcrumbs: false,
        //   roles: ["devicemanufacture"],
        // },
      ]
    },
    {
      id: "icons-tag",
      title: "Tagging & Activation",
      type: "collapse",
      icon: icons.IconTag,
      roles: ["dealer"],
      children: [
        {
          id: "new-tagging",
          title: "Tag Device to Vehicle",
          type: "item",
          url: "/tag/device-vehicle",
          breadcrumbs: false,
          roles: ["dealer"],
        },
        // {
        //   id: "tagged-device",
        //   title: "UnTagged Device",
        //   type: "item",
        //   url: "/device/show-tagged-device",
        //   breadcrumbs: false,
        //   roles: ["dealer"],
        // },
        // {
        //   id: "government-certificate",
        //   title: "Government Approval Certificate",
        //   type: "item",
        //   url: "tag/government-certificate-upload",
        //   breadcrumbs: false,
        //   roles: ["dealer", "certificate_agent"],
        // },

        // {
        //   id: "view-pending",
        //   title: "Pending for Owner Approval",
        //   type: "item",
        //   url: "/tag/unapproved-vehicle",
        //   breadcrumbs: false,
        //   roles: ["dealer"],
        // },
        // {
        //   id: "vahan-verification",
        //   title: "Vahan Verification",
        //   type: "item",
        //   url: "/tag/vahan-verification",
        //   breadcrumbs: false,
        //   roles: ["dealer"],
        // }
      ],
    },
    {
      id: "download-tagging-receipt",
      title: "Download Activation Invoice",
      type: "item",
      url: "/tag/download-receipt",
      icon: icons.IconChecks,
      breadcrumbs: false,
      roles: ["dealer"],
    },
    {
      id: "esim-extension",
      title: "Esim Extension",
      type: "item",
      url: "/esim-extension",
      icon: icons.IconDeviceSim1,
      breadcrumbs: false,
      roles: ["dealer"],
    },
    // {
    //   id: "device-tag-invoice",
    //   title: "Auto Invoice Report",
    //   type: "item",
    //   url: "/tag/device-tag-invoice",
    //   icon: icons.IconFileInvoice,
    //   breadcrumbs: false,
    //   roles: ["dealer", "devicemanufacture", "superadmin"],
    // },
    //       {
    //   id: "unused-stock",
    //   title: "Unused Stock",
    //   type: "item",
    //   url: "/manufacturer/unused-stock",
    //   icon: icons.IconArchive,
    //   breadcrumbs: false,
    //   roles: ["devicemanufacture"],
    // },
    // {
    //   id: "poi-viewer",
    //   title: "POI Viewer",
    //   type: "item",
    //   url: "/poi-viewer",
    //   icon: icons.IconMapPin,
    //   breadcrumbs: false,
    //   roles: ["superadmin", "stateadmin", "owner", "dto"],
    // },
    {
      id: "icons-report",
      title: "Reports",
      type: "collapse",
      icon: icons.IconReport,
      roles: ["dealer", "devicemanufacture", "stateadmin", "sosadmin", "superadmin", "dtorto", "owner", "certificateadmin", "certificateteamlead","factorymanager"],
      children: [
        {
          id: "sos-other-list",
          title: "SOS Users",
          type: "item",
          url: "/user/sos-other-list",
          breadcrumbs: false,
          roles: ["sosadmin"],
        },
        // {
        //   id: "sos-report",
        //   title: "SOS Report",
        //   type: "item",
        //   url: "/sos-report",
        //   breadcrumbs: false,
        //   roles: ["superadmin", "sosadmin"],
        // },
        {
          id: "sos-call-list",
          title: "SOS Call List",
          type: "item",
          url: "/sos-call-list",
          icon: icons.IconUrgent,
          breadcrumbs: false,
          roles: ["sosadmin"],
        },
        // {
        //   id:"sos_timestamp",
        //   title:"SOS Timestamp",
        //   type:"item",
        //   url:"/sosTimestamp",
        //   breadcrumbs:false,
        //   roles:["sosadmin"]
        // },
        {
          id: "all-notice-list",
          title: "Notices",
          type: "item",
          url: "/notice/all-notice-list",
          breadcrumbs: false,
          roles: ["superadmin"],
        },
        {
          id: "user-list",
          title: "Users",
          type: "item",
          url: "/user/registeredUser",
          breadcrumbs: false,
          roles: ["superadmin"],
        },
        // {
        //   id: "admin-user-list",
        //   title: "State Admin",
        //   type: "item",
        //   url: "/user/state-admin-list",
        //   breadcrumbs: false,
        //   roles: ["superadmin"],
        // },
        {
          id: "manufacturer-list",
          title: "Manufacturer",
          type: "item",
          url: "/user/manufacturer-list",
          breadcrumbs: false,
          roles: ["superadmin"],
        },
        {
          id: "technician-list",
          title: "Technician List",
          type: "item",
          url: "/user/registeredTechnician",
          breadcrumbs: false,
          roles: ["superadmin"],
        },
        {
          id: "certificate-admin-list",
          title: "Certificate Admin List",
          type: "item",
          url: "/user/registeredcertifateadmin",
          breadcrumbs: false,
          roles: ["superadmin"],
        },
        {
          id: "certificate-teamlead-list",
          title: "Certificate Team Lead List",
          type: "item",
          url: "/user/registeredcertifateteamlead",
          breadcrumbs: false,
          roles: ["superadmin", "certificateadmin"],
        },
        {
          id: "certificate-executive-list",
          title: "Certificate Executive List",
          type: "item",
          url: "/user/registeredcertifateexecutive",
          breadcrumbs: false,
          roles: ["superadmin", "certificateadmin"],
        },
        // {
        //   id: "sos-admin-list",
        //   title: "SOS Admin",
        //   type: "item",
        //   url: "/user/sos-user-list",
        //   breadcrumbs: false,
        //   roles: ["superadmin"],
        // },
        // {
        //   id: "esim-provider-list",
        //   title: "M2M Provider",
        //   type: "item",
        //   url: "/user/esim-provider-list",
        //   breadcrumbs: false,
        //   roles: ["superadmin"],
        // },
        {
          id: "stocks-report",
          title: "Stock Status Report",
          type: "item",
          url: "/stock-reports",
          breadcrumbs: false,
          roles: ["superadmin"],
        },
        {
          id: "device-stock-feature-report",
          title: "Device Stock Feature Report",
          type: "item",
          url: "/stock-device-feature",
          breadcrumbs: false,
          roles: ["superadmin","factorymanager"],
        },
        // {
        //   id: "all-device",
        //   title: "Stock Report",
        //   type: "item",
        //   url: "/device/show-device",
        //   breadcrumbs: false,
        //   roles: ["dealer"],
        // },
        // {
        //   id: "view-device",
        //   title: "Fitment Report",
        //   type: "item",
        //   url: "/device/show-available-device",
        //   breadcrumbs: false,
        //   roles: ["dealer"],
        // },
        {
          id: "dealer-list",
          title: "Dealers",
          type: "item",
          url: "/user/dealerList",
          breadcrumbs: false,
          roles: ["superadmin", "stateadmin", "devicemanufacture"],
        },
        {
          id: "vehicle-owner",
          title: "Vehicle Owner",
          type: "item",
          url: "/user/vehicle-owner-list",
          breadcrumbs: false,
          roles: ["superadmin", "stateadmin"],
        },
        // {
        //   id: "vehicle-owner",
        //   title: "Vehicle Owner Report",
        //   type: "item",
        //   url: "/user/vehicle-owner-list",
        //   breadcrumbs: false,
        //   roles: ["dealer"],
        // },
        // {
        //   id: "dto-user-list",
        //   title: "DTO User List",
        //   type: "item",
        //   url: "/user/dto-user-list",
        //   breadcrumbs: false,
        //   roles: ["stateadmin"],
        // },
        // {
        //   id: "emergency-list",
        //   title: "Emergency",
        //   type: "item",
        //   url: "/emergency-list",
        //   breadcrumbs: false,
        //   roles: ["superadmin"],
        // },
        // {
        //   id: "route-deviation",
        //   title: "Route Deviation Alert",
        //   type: "item",
        //   url: "/route-deviation",
        //   breadcrumbs: false,
        //   roles: ["superadmin"],
        // },
        // {
        //   id: "untagged-list",
        //   title: "Untagged",
        //   type: "item",
        //   url: "/untagged-list",
        //   breadcrumbs: false,
        //   roles: ["superadmin"],
        // },
        // {
        //   id: "fitment-receipt",
        //   title: "Fitment Receipt",
        //   type: "item",
        //   url: "/fitment-receipt",
        //   breadcrumbs: false,
        //   roles: ["superadmin"],
        // },
        // {
        //   id: "geo-fence",
        //   title: "Geo Fence",
        //   type: "item",
        //   url: "/geo-fence",
        //   breadcrumbs: false,
        //   roles: ["superadmin"],
        // },
        // {
        //   id: "alert-list",
        //   title: "Alert",
        //   type: "item",
        //   url: "/alert-list",
        //   breadcrumbs: false,
        //   roles: ["superadmin"],
        // },
        // {
        //   id: "performance-list",
        //   title: "Performance List",
        //   type: "item",
        //   url: "/performance/list",
        //   breadcrumbs: false,
        //   roles: ["superadmin"],
        // },
        // {
        //   id: "all-device",
        //   title: "View Stocks",
        //   type: "item",
        //   url: "/device/show-device",
        //   breadcrumbs: false,
        //   roles: ["devicemanufacture"],
        // },
        {
          id: "combined-stock",
          title: "Device Report",
          type: "item",
          url: "/device/combined-stock-report",
          breadcrumbs: false,
          roles: ["superadmin", "devicemanufacture"],
        },
        // {
        //   id: "device-alert-log",
        //   title: "Device Alert Log",
        //   type: "item",
        //   url: "/reports/alert-log",
        //   breadcrumbs: false,
        //   roles: ["superadmin","dtorto","stateadmin",'owner'],
        // },
        // {
        //   id: "all-tagged-devices",
        //   title: "All Tagged Devices",
        //   type: "item",
        //   url: "/device/all-tagged-devices",
        //   breadcrumbs: false,
        //   roles: ["stateadmin"],
        // },
        {
          id: 'gps-data-log',
          title: 'GPS Data Log',
          type: 'item',
          url: '/reports/gps-data-log',
          icon: icons.IconDeviceAnalytics,
          breadcrumbs: false,
          roles: ['superadmin', 'stateadmin']
        },
        {
          id: 'activation-log-report',
          title: 'Activation Log Report',
          type: 'item',
          url: '/reports/activation-log-report',
          icon: icons.IconDeviceAnalytics,
          breadcrumbs: false,
          roles: ['superadmin']
        },
        {
          id: 'emergency-data-logs',
          title: 'Emergency Data Logs',
          type: 'item',
          url: '/reports/emergency-data-logs',
          icon: icons.IconDeviceAnalytics,
          breadcrumbs: false,
          roles: ['superadmin']
        },
        {
          id: 'health-packet-log',
          title: 'Health Packet Log',
          type: 'item',
          url: '/reports/health-packet-log',
          icon: icons.IconDeviceAnalytics,
          breadcrumbs: false,
          roles: ['superadmin']
        },
        {
          id: 'api-data-log',
          title: 'Event Data Log',
          type: 'item',
          url: '/reports/api-data-log',
          icon: icons.IconDeviceAnalytics,
          breadcrumbs: false,
          roles: ['superadmin']
        },
        {
          id: 'activated-device-report',
          title: 'Activated Device Report',
          type: 'item',
          url: '/reports/activated-device-report',
          breadcrumbs: false,
          roles: ['superadmin', 'dtorto']
        },
        {
          id: 'alert-report',
          title: 'Alert Report',
          type: 'item',
          url: '/reports/alert-report',
          breadcrumbs: false,
          roles: ['superadmin', 'stateadmin', 'dtorto', 'owner']
        },
        // {
        //   id: 'poi-report',
        //   title: 'POI Report',
        //   type: 'item',
        //   url: '/reports/poi-report',
        //   breadcrumbs: false,
        //   roles: ['superadmin', 'stateadmin', 'dto', 'owner']
        // },
        // {
        //   id: 'incident-report',
        //   title: 'Incident Report',
        //   type: 'item',
        //   url: '/reports/incident-report',
        //   breadcrumbs: false,
        //   roles: ['superadmin']
        // },
        {
          id: 'device-health-report',
          title: 'Device Health Report',
          type: 'item',
          url: '/reports/device-health-report',
          breadcrumbs: false,
          roles: ['superadmin', 'stateadmin']
        },
        {
          id: 'Sales-Invoice-Report',
          title: 'Sales Invoice Report',
          type: 'item',
          url: '/device/salesInvoiceReport',
          breadcrumbs: false,
          roles: ['superadmin', 'devicemanufacture', 'dealer']
        },
        {
          id: 'user-statistics-report',
          title: 'User Statistics Report',
          type: 'item',
          url: '/reports/user-statistics-report',
          breadcrumbs: false,
          roles: ['superadmin']
        },
        // {
        //   id: "all-holiday-list",
        //   title: "School Holidays",
        //   type: "item",
        //   url: "/holiday/all-holiday-list",
        //   breadcrumbs: false,
        //   roles: ["superadmin", "owner"],
        // },
      ],
    },
  ],
};

export default user;
